import * as tslib_1 from "tslib";
import { EvalStack } from './eval-stack';
import { Item } from './item';
import { Value } from './value';
import { Record } from './record';
import { Selector } from './selector';
import { Murmur3 } from './murmur3';
var Func = (function (_super) {
    tslib_1.__extends(Func, _super);
    function Func() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Func.prototype.partialInvoke = function (args, stack, expr) {
        return undefined;
    };
    Func.prototype.toAny = function () {
        return this;
    };
    Func.prototype.writeRecon = function (output) {
    };
    Func.prototype.toRecon = function () {
        return '';
    };
    Func.prototype.toReconBlock = function () {
        return '';
    };
    Func.prototype.compare = function (that) {
        if (that instanceof Func) {
            var order = this.name.localeCompare(that.name);
            return order < 0 ? -1 : order > 0 ? 1 : 0;
        }
        else if (that instanceof Item.Expr || that === Value.Extant || that === Value.Absent) {
            return -1;
        }
        else {
            return 1;
        }
    };
    Func.prototype.equals = function (that) {
        if (that instanceof Func) {
            return this.name === that.name;
        }
        return false;
    };
    Func.prototype.hashCode = function () {
        return Murmur3.mash(Murmur3.mix(0xB58EA7B4, Murmur3.hash(this.name)));
    };
    Func.prototype.toString = function () {
        return '[' + 'Func' + ' ' + this.name + ']';
    };
    Func.Eager = undefined;
    Func.Abs = undefined;
    Func.Ceil = undefined;
    Func.Floor = undefined;
    Func.Round = undefined;
    Func.Pow = undefined;
    Func.Sqrt = undefined;
    Func.Max = undefined;
    Func.Min = undefined;
    Func.Count = undefined;
    Func.Random = undefined;
    Func.Rate = undefined;
    Func.Percent = undefined;
    Func.Number = undefined;
    Func.String = undefined;
    Func.ConsoleLog = undefined;
    return Func;
}(Value));
export { Func };
Item.Func = Func;
var EagerFunc = (function (_super) {
    tslib_1.__extends(EagerFunc, _super);
    function EagerFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EagerFunc.prototype, "name", {
        get: function () {
            return 'eager';
        },
        enumerable: true,
        configurable: true
    });
    EagerFunc.prototype.invoke = function (args, stack) {
        return args.evaluate(stack);
    };
    EagerFunc.prototype.partialInvoke = function (args, stack, expr) {
        return args.evaluate(stack);
    };
    return EagerFunc;
}(Func));
export { EagerFunc };
Func.Eager = new EagerFunc();
var AbsFunc = (function (_super) {
    tslib_1.__extends(AbsFunc, _super);
    function AbsFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AbsFunc.prototype, "name", {
        get: function () {
            return 'abs';
        },
        enumerable: true,
        configurable: true
    });
    AbsFunc.prototype.invoke = function (args, stack) {
        args = args.evaluate(stack).toValue();
        var x = args.numberValue();
        if (x !== undefined) {
            return Item.Num.valueOf(Math.abs(x));
        }
        return Value.Absent;
    };
    return AbsFunc;
}(Func));
export { AbsFunc };
Func.Abs = new AbsFunc();
var CeilFunc = (function (_super) {
    tslib_1.__extends(CeilFunc, _super);
    function CeilFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CeilFunc.prototype, "name", {
        get: function () {
            return 'ceil';
        },
        enumerable: true,
        configurable: true
    });
    CeilFunc.prototype.invoke = function (args, stack) {
        args = args.evaluate(stack).toValue();
        var x = args.numberValue();
        if (x !== undefined) {
            return Item.Num.valueOf(Math.ceil(x));
        }
        return Value.Absent;
    };
    return CeilFunc;
}(Func));
export { CeilFunc };
Func.Ceil = new CeilFunc();
var FloorFunc = (function (_super) {
    tslib_1.__extends(FloorFunc, _super);
    function FloorFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(FloorFunc.prototype, "name", {
        get: function () {
            return 'floor';
        },
        enumerable: true,
        configurable: true
    });
    FloorFunc.prototype.invoke = function (args, stack) {
        args = args.evaluate(stack).toValue();
        var x = args.numberValue();
        if (x !== undefined) {
            return Item.Num.valueOf(Math.floor(x));
        }
        return Value.Absent;
    };
    return FloorFunc;
}(Func));
export { FloorFunc };
Func.Floor = new FloorFunc();
var RoundFunc = (function (_super) {
    tslib_1.__extends(RoundFunc, _super);
    function RoundFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RoundFunc.prototype, "name", {
        get: function () {
            return 'round';
        },
        enumerable: true,
        configurable: true
    });
    RoundFunc.prototype.invoke = function (args, stack) {
        args = args.evaluate(stack).toValue();
        var x = args.numberValue();
        if (x !== undefined) {
            return Item.Num.valueOf(Math.round(x));
        }
        return Value.Absent;
    };
    return RoundFunc;
}(Func));
export { RoundFunc };
Func.Round = new RoundFunc();
var PowFunc = (function (_super) {
    tslib_1.__extends(PowFunc, _super);
    function PowFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PowFunc.prototype, "name", {
        get: function () {
            return 'pow';
        },
        enumerable: true,
        configurable: true
    });
    PowFunc.prototype.invoke = function (args, stack, expr) {
        var x = args.getItem(0).evaluate(stack).numberValue();
        var y = args.getItem(1).evaluate(stack).numberValue();
        if (x !== undefined && y !== undefined) {
            return Item.Num.valueOf(Math.pow(x, y));
        }
        return Value.Absent;
    };
    return PowFunc;
}(Func));
export { PowFunc };
Func.Pow = new PowFunc();
var SqrtFunc = (function (_super) {
    tslib_1.__extends(SqrtFunc, _super);
    function SqrtFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SqrtFunc.prototype, "name", {
        get: function () {
            return 'sqrt';
        },
        enumerable: true,
        configurable: true
    });
    SqrtFunc.prototype.invoke = function (args, stack) {
        args = args.evaluate(stack).toValue();
        var x = args.numberValue();
        if (x !== undefined) {
            return Item.Num.valueOf(Math.sqrt(x));
        }
        return Value.Absent;
    };
    return SqrtFunc;
}(Func));
export { SqrtFunc };
Func.Sqrt = new SqrtFunc();
var MaxFunc = (function (_super) {
    tslib_1.__extends(MaxFunc, _super);
    function MaxFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MaxFunc.prototype, "name", {
        get: function () {
            return 'max';
        },
        enumerable: true,
        configurable: true
    });
    MaxFunc.prototype.invoke = function (args, stack, expr) {
        var x;
        var y;
        if (args.length >= 2) {
            x = args.getItem(0).evaluate(stack).numberValue();
            y = args.getItem(1).evaluate(stack).numberValue();
        }
        else {
            x = args.evaluate(stack).numberValue();
        }
        if (x !== undefined && isFinite(x)) {
            expr.state = expr.state || {};
            if (y === undefined) {
                y = Math.max(x, expr.state.nax || x);
                expr.state.nax = y;
            }
            if (y !== undefined && isFinite(y)) {
                return Item.Num.valueOf(Math.max(x, y));
            }
        }
        return Value.Absent;
    };
    MaxFunc.prototype.partialInvoke = function (args, stack, expr) {
        if (args.length === 1) {
            args = args.evaluate(stack).toValue();
            return this.invoke(args, stack, expr);
        }
        return undefined;
    };
    return MaxFunc;
}(Func));
export { MaxFunc };
Func.Max = new MaxFunc();
var MinFunc = (function (_super) {
    tslib_1.__extends(MinFunc, _super);
    function MinFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MinFunc.prototype, "name", {
        get: function () {
            return 'min';
        },
        enumerable: true,
        configurable: true
    });
    MinFunc.prototype.invoke = function (args, stack, expr) {
        var x;
        var y;
        if (args.length >= 2) {
            x = args.getItem(0).evaluate(stack).numberValue();
            y = args.getItem(1).evaluate(stack).numberValue();
        }
        else {
            x = args.evaluate(stack).numberValue();
        }
        if (x !== undefined && isFinite(x)) {
            expr.state = expr.state || {};
            if (y === undefined) {
                y = Math.min(x, expr.state.min || x);
                expr.state.min = y;
            }
            if (y !== undefined && isFinite(y)) {
                return Item.Num.valueOf(Math.min(x, y));
            }
        }
        return Value.Absent;
    };
    MinFunc.prototype.partialInvoke = function (args, stack, expr) {
        if (args.length === 1) {
            args = args.evaluate(stack).toValue();
            return this.invoke(args, stack, expr);
        }
        return undefined;
    };
    return MinFunc;
}(Func));
export { MinFunc };
Func.Min = new MinFunc();
var CountFunc = (function (_super) {
    tslib_1.__extends(CountFunc, _super);
    function CountFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CountFunc.prototype, "name", {
        get: function () {
            return 'count';
        },
        enumerable: true,
        configurable: true
    });
    CountFunc.prototype.invoke = function (args, stack, expr) {
        if (args instanceof Selector) {
            var count_1 = 0;
            args.forSelected(stack, function (stack) {
                count_1 += 1;
            }, this);
            return Item.Num.valueOf(count_1);
        }
        else if (args instanceof Record) {
            return Item.Num.valueOf(args.length);
        }
        return Value.Absent;
    };
    return CountFunc;
}(Func));
export { CountFunc };
Func.Count = new CountFunc();
var PercentFunc = (function (_super) {
    tslib_1.__extends(PercentFunc, _super);
    function PercentFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(PercentFunc.prototype, "name", {
        get: function () {
            return 'percent';
        },
        enumerable: true,
        configurable: true
    });
    PercentFunc.prototype.invoke = function (args, stack, expr) {
        var value;
        var total;
        if (args.length >= 2) {
            value = args.getItem(0).evaluate(stack).numberValue();
            total = args.getItem(1).evaluate(stack).numberValue();
        }
        else {
            value = args.evaluate(stack).numberValue();
        }
        if (value !== undefined && isFinite(value)) {
            expr.state = expr.state || {};
            if (total === undefined) {
                total = Math.max(value, expr.state.total || value);
                expr.state.total = total;
            }
            if (total !== 0 && isFinite(total)) {
                return Item.Text.valueOf(Math.round(100 * value / total) + '%');
            }
        }
        return Value.Absent;
    };
    PercentFunc.prototype.partialInvoke = function (args, stack, expr) {
        if (args.length === 1) {
            args = args.evaluate(stack).toValue();
            return this.invoke(args, stack, expr);
        }
        return undefined;
    };
    return PercentFunc;
}(Func));
export { PercentFunc };
Func.Percent = new PercentFunc();
var RandomFunc = (function (_super) {
    tslib_1.__extends(RandomFunc, _super);
    function RandomFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RandomFunc.prototype, "name", {
        get: function () {
            return 'random';
        },
        enumerable: true,
        configurable: true
    });
    RandomFunc.prototype.invoke = function (args, stack) {
        var lower = args.length >= 1 ? args.getItem(0).evaluate(stack).numberValue(0) : 0;
        var upper = args.length >= 2 ? args.getItem(1).evaluate(stack).numberValue(lower + 1) : lower + 1;
        var value = lower + Math.random() * (upper - lower);
        return Item.Num.valueOf(value);
    };
    return RandomFunc;
}(Func));
export { RandomFunc };
Func.Random = new RandomFunc();
var RateFunc = (function (_super) {
    tslib_1.__extends(RateFunc, _super);
    function RateFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RateFunc.prototype, "name", {
        get: function () {
            return 'rate';
        },
        enumerable: true,
        configurable: true
    });
    RateFunc.prototype.invoke = function (args, stack, expr) {
        var value;
        var period;
        if (args.length >= 2) {
            value = args.getItem(0).evaluate(stack).numberValue();
            period = args.getItem(1).evaluate(stack).numberValue();
        }
        else {
            value = args.evaluate(stack).numberValue();
        }
        if (value !== undefined && isFinite(value)) {
            expr.state = expr.state || {};
            if (period === undefined) {
                period = 1000;
            }
            if (expr.state.t0 === undefined) {
                expr.state.t0 = Date.now();
                expr.state.v0 = value;
            }
            else {
                var t1 = Date.now();
                var dt = t1 - expr.state.t0;
                if (dt > period && t1 > expr.state.t0 || dt > 2 * period) {
                    var dv = value - expr.state.v0;
                    expr.state.t0 = t1;
                    expr.state.v0 = value;
                    expr.state.dt = dt;
                    expr.state.dv = dv;
                }
                if (expr.state.dt !== undefined) {
                    var rate = period * expr.state.dv / (expr.state.dt || 1);
                    return Item.Num.valueOf(rate);
                }
            }
        }
        return Value.Absent;
    };
    RateFunc.prototype.partialInvoke = function (args, stack, expr) {
        args = args.evaluate(stack).toValue();
        return this.invoke(args, stack, expr);
    };
    return RateFunc;
}(Func));
export { RateFunc };
Func.Rate = new RateFunc();
var NumberFunc = (function (_super) {
    tslib_1.__extends(NumberFunc, _super);
    function NumberFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(NumberFunc.prototype, "name", {
        get: function () {
            return 'number';
        },
        enumerable: true,
        configurable: true
    });
    NumberFunc.prototype.invoke = function (args, stack) {
        args = args.evaluate(stack).toValue();
        if (args instanceof Item.Num) {
            return args;
        }
        else {
            var x = args.numberValue();
            if (x !== undefined) {
                return Item.Num.valueOf(x);
            }
        }
        return Value.Absent;
    };
    return NumberFunc;
}(Func));
export { NumberFunc };
Func.Number = new NumberFunc();
var StringFunc = (function (_super) {
    tslib_1.__extends(StringFunc, _super);
    function StringFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(StringFunc.prototype, "name", {
        get: function () {
            return 'string';
        },
        enumerable: true,
        configurable: true
    });
    StringFunc.prototype.invoke = function (args, stack) {
        args = args.evaluate(stack).toValue();
        if (args instanceof Item.Text) {
            return args;
        }
        else {
            var s = args.stringValue();
            if (s !== undefined) {
                return Item.Text.valueOf(s);
            }
        }
        return Value.Absent;
    };
    return StringFunc;
}(Func));
export { StringFunc };
Func.String = new StringFunc();
var ConsoleLogFunc = (function (_super) {
    tslib_1.__extends(ConsoleLogFunc, _super);
    function ConsoleLogFunc() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ConsoleLogFunc.prototype, "name", {
        get: function () {
            return 'console.log';
        },
        enumerable: true,
        configurable: true
    });
    ConsoleLogFunc.prototype.invoke = function (args, stack) {
        args = args.evaluate(stack).toValue();
        console.log(args.toAny());
        return Item.Absent;
    };
    return ConsoleLogFunc;
}(Func));
export { ConsoleLogFunc };
Func.ConsoleLog = new ConsoleLogFunc();
Item.GlobalScope = Value.empty()
    .slot('eager', Func.Eager)
    .slot('abs', Func.Abs)
    .slot('ceil', Func.Ceil)
    .slot('floor', Func.Floor)
    .slot('round', Func.Round)
    .slot('pow', Func.Pow)
    .slot('sqrt', Func.Sqrt)
    .slot('max', Func.Max)
    .slot('min', Func.Min)
    .slot('count', Func.Count)
    .slot('random', Func.Random)
    .slot('rate', Func.Rate)
    .slot('percent', Func.Percent)
    .slot('number', Func.Number)
    .slot('string', Func.String)
    .slot('console', Value.empty()
    .slot('log', Func.ConsoleLog))
    .slot('log', Func.ConsoleLog)
    .commit();
EvalStack.GlobalScope = Item.GlobalScope;
//# sourceMappingURL=data:application/json;base64,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